
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { JobService } from '../job.service';
import { Job } from '../../../domain/job';
import { SITE_TITLE } from '../../../shared/constants';

@Component({
  selector: 'app-jobs-gallery',
  imports: [
    RouterModule
],
  templateUrl: './job-gallery.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './job-gallery.component.scss'
})
export class JobGalleryComponent {
  constructor(
    private meta: Meta, private title: Title,
    private router: Router,
    private jobsService: JobService) {
  }

  jobs: Job[] = []

  ngOnInit(): void {
    this.title.setTitle(SITE_TITLE + ' | Job opportunities');
    this.meta.updateTag({ name: 'description', content: 'nordnative jobs list' });
    this.meta.updateTag({ name: 'keywords', content: 'Jobs, Jobs catalogue, Software Development' });

    this.jobs = this.jobsService.getJobs()
  }

  routeTo(path: string) {
    this.router.navigate([path]);
  }
}
